import {BUSCAR_TRECHOS_RESERVAS_ITINERARIO, LIMPAR_TRECHOS_RESERVAS_ITINERARIO} from '../../actions/types'

const initialState = undefined

export default function reducerTrechosReservasItinerario(state = [], action = initialState) {
    switch (action.type) {
        case BUSCAR_TRECHOS_RESERVAS_ITINERARIO: {
            const trechos = action.payload.data;

            if (trechos) {
                return trechos
            }
            return []
        }

        case LIMPAR_TRECHOS_RESERVAS_ITINERARIO: {
            return []
        }
        default: {
            return state
        }
    }
}